export function maskIban(iban: string): string {
  const clean = iban.replace(/\s/g, "");
  return `•••• •••• •••• •••• ${clean.slice(-4)}`;
}
 
export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" });
}
 
export function formatAmount(amount: number): string {
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(amount);
}
 
export function computeProrata(pricePerYear: number, daysRemaining: number): number {
  return Math.round((pricePerYear * daysRemaining) / 365);
}

export function maskCard(last4: string, brand?: string): string {
  return `${brand ? brand + " " : ""}•••• •••• •••• ${last4}`;
}
